/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import { setActiveSelection } from 'state/actions/embedsState/embedManagementState/content_status';
import Background from 'material/embeds/embed/shared/background/background';



/* ========== ~~~~~~~~~~ EMBED : BACKGROUND : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ embedsState }, { contentId }) => {
    const currentContentState = embedsState.embedManagementState.contentStatus['contents'][contentId];
    const currentContentType = currentContentState.contentType === 'story'? 'story' : 'questionBased';
    return {
        isSelected: embedsState.embedManagementState.contentStatus['activeSelection'] === 'background',
        backgroundImageURL: currentContentState[currentContentType]['backgroundImageURL'],
        previewBackgroundImageURL: currentContentState[currentContentType]['previewBackgroundImageURL'],
        backgroundColor: currentContentState[currentContentType]['backgroundColor']
    };
};


const mapDispatchToProps = dispatch => ({
    setActiveSelection: selection => dispatch(setActiveSelection(selection)),
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Background);
